import { render, staticRenderFns } from "./QuitaDelete.vue?vue&type=template&id=7739634b"
import script from "./QuitaDelete.vue?vue&type=script&lang=js"
export * from "./QuitaDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports